module.exports = __webpack_public_path__ + "img/transfer29.28587dfd.jpeg";